export default __webpack_public_path__ + "static/media/FerrousImg.c44df47b.jpg";